@if (investmentTypes() && summary() && iconSet()) {
  <div class="title-row mt-4 grid grid-cols-2">
    <div class="cols-span-6">
      <div class="table-title flex text-md lg:text-2xl">Investments
      </div>
      <div class="since-inception-text text-sm lg:text-md" data-cy="tableCurrency">Since Inception | Expressed in
      {{currency()}} (in millions)</div>
    </div>
    <div class="cols-span-6 flex flex-row flex-wrap pl-0 expanded-export">
      <app-expanded-view-slider (updateTableColumns)="updateColumns($event)"
      [expandView]="expandView"></app-expanded-view-slider>
      <div class="text-right" tourAnchor="series.dashboard.export">
        @if (deals.length > 0) {
          <button type="button"
            (click)="exportSeriesDealsDataToCsv($event)"
            class="btn export-csv-btn btn-outline-primary text-xs lg:text-md md:before:top-2 lg:before:top-3 before:top-7"
            data-cy="exportCsvButton"> <mat-icon
          fontSet="material-icons-outlined" class="export-icon">content_paste_go</mat-icon>
        Export to Excel</button>
      }
    </div>
  </div>
</div>
@if (!isAggregatedSeries()) {
  <div class="flex flex-row title-values">
    <div class="flex-initial w-32">
      <div class="table-tvpi-value text-md lg:text-2xl" data-cy="summaryTvpiValue">{{summary()?.tvpi | tvpiValueFormat}}
      </div>
      <div class="table-tvpi-text text-sm lg:text-md">TVPI</div>
    </div>
    <div class="flex-initial w-32">
      <div class="table-irr-value text-md lg:text-2xl" data-cy="summaryIrrValue">{{summary()?.irr | irrValueFormat}}</div>
      <div class="table-irr-text text-sm lg:text-md">IRR </div>
    </div>
  </div>
}
@if (deals.length > 0) {
  <div class="card series-deals-card bg-white" data-cy="seriesDealCard">
    <div class="overflow-x-auto" data-cy="scrollTable0" (scroll)="scrollTableHandler($event)">
      <div class="investment-type-table">
        <table mat-table matSort [dataSource]="dataSource"
          class="mb-3 investment-type-section bg-white" multiTemplateDataRows
          [ngClass]="{'width-3300 lg:min-w-3300':expandView}">
          <!-- Name Column -->
          <ng-container matColumnDef="name" sticky>
            <th mat-header-cell mat-sort-header *matHeaderCellDef
              class="text-left sub-header text-sm lg:text-md min-w-175"
              [ngClass]="{'width-305 max-w-175 lg:min-w-305' : expandView, 'width-23' : !expandView, 'shadow-background':displayShadowOnTable, 'normal-background':!displayShadowOnTable}">
            Deal Name </th>
            <td mat-cell *matCellDef="let deal; let k = dataIndex"
              class="text-left deal-row text-sm lg:text-md"
              [ngClass]="{'deal-name': !deal.disableDrillThrough, 'width-23': !expandView, 'width-305': expandView, 'shadow-background':displayShadowOnTable, 'normal-background':!displayShadowOnTable}">
              <div class="deal-name-div">
                  @if (!deal.disableDrillThrough) {
                    <a
                      routerLinkActive="active"
                      [routerLink]=" ['/investor', investorId(), 'series' , seriesId(), 'deal' , deal.masterId]"
                      [queryParams]="{'reportingdate':reportingPeriod()}" data-cy="dealName"
                      (click)="activityTracking.navigateToDashboard('Deal', deal, 'series deal table')">
                      {{deal.name}}
                    </a>
                  }
                  @if (deal.disableDrillThrough) {
                    <span data-cy="dealNameDisabled">
                      {{deal.name}}
                    </span>
                  }
                  <img class="expand-collapse-icon-holding" [ngClass]="{'hidden': !deal.showHoldings}"
                  alt="{{ deal.isExpanded ? 'Collapse' : 'Expand' }}"
                  (keydown.enter)="deal.isExpanded = !deal.isExpanded; activityTracking.expandOrCollapseToggled('deal', deal, 'series deal table', deal.isExpanded)"
                  (keydown.space)="deal.isExpanded = !deal.isExpanded; activityTracking.expandOrCollapseToggled('deal', deal, 'series deal table', deal.isExpanded)"
                  tabindex="0"
                  role="button"
                  (click)="deal.isExpanded = !deal.isExpanded; activityTracking.expandOrCollapseToggled('deal', deal, 'series holdings table', deal.isExpanded)"
                  src="{{ deal.isExpanded ? iconSet()?.['icon.series.collapse'] : iconSet()?.['icon.expand']}}"
                  attr.data-cy="dealCollapseIcon0{{k}}">
                </div>
              </td>
            </ng-container>
            <!-- Commitment Date Column -->
            <ng-container matColumnDef="commitmentDate">
              <th mat-header-cell mat-sort-header start="desc" *matHeaderCellDef
                class="text-left width-120 sub-header text-sm lg:text-md min-w-70 max-w-70 lg:min-w-120">
                Commitment Date
              </th>
              <td mat-cell *matCellDef="let deal" class="text-left width-120 deal-row text-sm lg:text-md"
                data-cy="dealCommitmentDate">
                {{deal.earliestCommitmentDate | dateFormat: 'MMM-yy'}}
              </td>
            </ng-container>
            <!-- Sector Column -->
            <ng-container matColumnDef="sector">
              <th mat-header-cell mat-sort-header *matHeaderCellDef
                class="text-left sub-header text-sm lg:text-md min-w-85"
                [ngClass]="expandView ? 'width-160 max-w-85 lg:min-w-160' : 'width-12'">
              Sector </th>
              <td mat-cell *matCellDef="let deal" class="text-left deal-row text-sm lg:text-md"
                [ngClass]="expandView ? 'width-160' : 'width-12'" data-cy="dealSector">
                {{deal.sector}}
              </td>
            </ng-container>
            <!-- Commitment Column -->
            <ng-container matColumnDef="commitment">
              <th mat-header-cell mat-sort-header start="desc" *matHeaderCellDef
                class="text-right sub-header text-sm lg:text-md min-w-100"
              [ngClass]="expandView ? 'width-160 lg:min-w-160' : 'width-10'"> Commitment </th>
              <td mat-cell *matCellDef="let deal" class="text-right deal-row text-sm lg:text-md min-w-100"
                [ngClass]="expandView ? 'width-160 lg:min-w-160' : 'width-10'"
                data-cy="dealBalanceValue">
                {{deal.commitment |
              currencyFormat:currency():'Millions':true:true}} </td>
            </ng-container>
            <!-- Contributions Column -->
            <ng-container matColumnDef="contributions">
              <th mat-header-cell mat-sort-header start="desc" *matHeaderCellDef
                class="text-right sub-header text-sm lg:text-md min-w-100"
                [ngClass]="expandView ? 'width-245 lg:min-w-245' : 'width-10'">{{expandView ?
                'Reported ': ''}}Contributions
              </th>
              <td mat-cell *matCellDef="let deal" class="text-right deal-row text-sm lg:text-md min-w-100"
                [ngClass]="expandView ? 'width-245 lg:min-w-245' : 'width-10'"
                data-cy="dealBalanceValue">
                {{(expandView
                ?
                deal.reportedContributions : deal.contributions) |
              currencyFormat:currency():'Millions':true:true}} </td>
            </ng-container>
            <!-- Distributions Column -->
            <ng-container matColumnDef="distributions">
              <th mat-header-cell mat-sort-header start="desc" *matHeaderCellDef
                class="text-right sub-header text-sm lg:text-md min-w-100"
                [ngClass]="expandView ? 'width-245 lg:min-w-245' : 'width-10'">{{expandView ?
                'Reported ': ''}}Distributions
              </th>
              <td mat-cell *matCellDef="let deal" class="text-right deal-row text-sm lg:text-md min-w-100"
                [ngClass]="expandView ? 'width-245 lg:min-w-245' : 'width-10'"
                data-cy="dealBalanceValue">
                {{(expandView
                ?
                deal.reportedDistributions : deal.distributions) |
              currencyFormat:currency():'Millions':true:true}} </td>
            </ng-container>
            <!-- Net Asset Value Column -->
            <ng-container matColumnDef="nav">
              <th mat-header-cell mat-sort-header start="desc" *matHeaderCellDef
                class="text-right sub-header text-sm lg:text-md min-w-70"
              [ngClass]="expandView ? 'width-160 lg:min-w-160' : 'width-10'"> Net Asset Value </th>
              <td mat-cell *matCellDef="let deal" class="text-right deal-row text-sm lg:text-md min-w-70"
                [ngClass]="expandView ? 'width-160 post-valuation-date-section lg:min-w-160' : 'width-10'"
                data-cy="dealBalanceValue"> {{deal.nav | currencyFormat:currency():'Millions':true:true}}
              </td>
            </ng-container>
            <!-- Total Value Column -->
            <ng-container matColumnDef="totalValue">
              <th mat-header-cell mat-sort-header start="desc" *matHeaderCellDef
                class="text-right sub-header text-sm lg:text-md min-w-70"
              [ngClass]="expandView ? 'width-160 lg:min-w-160' : 'width-10'"> Total Value </th>
              <td mat-cell *matCellDef="let deal" class="text-right deal-row text-sm lg:text-md min-w-70"
                [ngClass]="expandView ? 'width-160 lg:min-w-160 post-valuation-date-section' : 'width-10'"
                data-cy="dealBalanceValue"> {{deal.totalValue |
              currencyFormat:currency():'Millions':true:true}} </td>
            </ng-container>
            <!-- TVPI Column -->
            <ng-container matColumnDef="tvpi">
              <th mat-header-cell mat-sort-header start="desc" *matHeaderCellDef
                class="text-right sub-header text-sm lg:text-md min-w-70"
              [ngClass]="expandView ? 'width-160 border-right' : 'width-7'"> TVPI </th>
              <td mat-cell *matCellDef="let deal" class="text-right deal-row text-sm lg:text-md min-w-70"
                [ngClass]="expandView ? 'width-160 border-right post-valuation-date-section' : 'width-7'"
              data-cy="dealTvpiValue"> {{deal.tvpi | tvpiValueFormat}} </td>
            </ng-container>
            <!-- IRR Column -->
            <ng-container matColumnDef="irr">
              <th mat-header-cell mat-sort-header start="desc" *matHeaderCellDef
                class="text-right sub-header text-sm lg:text-md min-w-70"
              [ngClass]="expandView ? 'width-160' : 'width-7'"> IRR </th>
              <td mat-cell *matCellDef="let deal" class="text-right deal-row text-sm lg:text-md min-w-70"
                [ngClass]="expandView ? 'width-160' : 'width-7'" data-cy="dealIrrValue"> {{deal.irr |
              irrValueFormat}} </td>
            </ng-container>
            <!-- Expanded View Columns -->
            <!-- Investment Status Column -->
            <ng-container matColumnDef="realizationType">
              <th mat-header-cell mat-sort-header *matHeaderCellDef
                class="text-left width-160 sub-header text-sm lg:text-md min-w-130 max-w-130 lg:min-w-160">
              Investment Status </th>
              <td mat-cell *matCellDef="let deal" class="text-left width-160 deal-row text-sm lg:text-md"
                data-cy="dealInvestmentStatus">
              {{deal.realizationType}} </td>
            </ng-container>
            <!-- Valuation Date Column -->
            <ng-container matColumnDef="valuationDate">
              <th mat-header-cell mat-sort-header start="desc" *matHeaderCellDef
                class="text-left width-140 sub-header text-sm lg:text-md min-w-80 max-w-80 lg:min-w-140">
                Valuation Date
              </th>
              <td mat-cell *matCellDef="let deal" class="text-left width-140 deal-row text-sm lg:text-md"
                data-cy="dealValutationDate">
                {{deal.valuationDate |
              dateFormat: 'M/d/yy'}} </td>
            </ng-container>
            <!-- Remaining Commitment Column -->
            <ng-container matColumnDef="remainingCommitment">
              <th mat-header-cell mat-sort-header start="desc" *matHeaderCellDef
                class="text-right width-245 sub-header text-sm lg:text-md min-w-100 lg:min-w-245">
                Remaining
                Commitment
              </th>
              <td mat-cell *matCellDef="let deal"
                class="text-right width-245 deal-row text-sm lg:text-md min-w-100 lg:min-w-245"
                data-cy="dealBalanceValueExpanded"> {{deal.remainingCommitment |
                currencyFormat:currency():'Millions':true:true}}
              </td>
            </ng-container>
            <!-- Reported Value Column -->
            <ng-container matColumnDef="reportedValue">
              <th mat-header-cell mat-sort-header start="desc" *matHeaderCellDef
                class="text-right width-160 sub-header text-sm lg:text-md min-w-70 lg:min-w-160">
                Reported Value
              </th>
              <td mat-cell *matCellDef="let deal"
                class="text-right width-160 deal-row text-sm lg:text-md min-w-70 lg:min-w-160"
                data-cy="dealBalanceValueExpanded"> {{deal.reportedValue |
              currencyFormat:currency():'Millions':true:true}} </td>
            </ng-container>
            <!-- Subsequent Contributions Column -->
            <ng-container matColumnDef="subsequentContributions">
              <th mat-header-cell mat-sort-header start="desc" *matHeaderCellDef
                class="text-right width-245 sub-header text-sm lg:text-md border-left min-w-100 lg:min-w-245">
                Subsequent
              Contributions </th>
              <td mat-cell *matCellDef="let deal"
                class="text-right width-245 deal-row border-left post-valuation-date-section text-sm lg:text-md  min-w-100 lg:min-w-245"
                data-cy="dealBalanceValueExpanded"> {{deal.subsequentContributions |
                currencyFormat:currency():'Millions':true:true}}
              </td>
            </ng-container>
            <!-- Subsequent Distributions Column -->
            <ng-container matColumnDef="subsequentDistributions">
              <th mat-header-cell mat-sort-header start="desc" *matHeaderCellDef
                class="text-right width-245 sub-header text-sm lg:text-md min-w-100 lg:min-w-245">
                Subsequent
              Distributions </th>
              <td mat-cell *matCellDef="let deal"
                class="text-right width-245 deal-row post-valuation-date-section text-sm lg:text-md min-w-100 lg:min-w-245"
                data-cy="dealBalanceValueExpanded"> {{deal.subsequentDistributions |
                currencyFormat:currency():'Millions':true:true}}
              </td>
            </ng-container>
            <!-- Subsequent Investment Gain/(Loss) Column -->
            <ng-container matColumnDef="fxGainLoss">
              <th mat-header-cell mat-sort-header start="desc" *matHeaderCellDef
                class="text-right width-160 sub-header text-sm lg:text-md min-w-100 lg:min-w-160"> Subsequent Investment
                Gain/(Loss)
              </th>
              <td mat-cell *matCellDef="let deal"
                class="text-right width-160 deal-row post-valuation-date-section text-sm lg:text-md min-w-100 lg:min-w-160"
                data-cy="dealBalanceValueExpanded"> {{deal.fxGainLoss |
                currencyFormat:currency():'Millions':true:true}}
              </td>
            </ng-container>
            <!-- Header row first section -->
            <ng-container matColumnDef="header-row-first-group" sticky>
              <th mat-header-cell *matHeaderCellDef [style.text-align]="'center'" [attr.colspan]="1"
                class="series-holding-table-th"
                [ngClass]="displayShadowOnTable ? 'shadow-background' : 'normal-background'">
              </th>
            </ng-container>
            <!-- Header row second section -->
            <ng-container matColumnDef="header-row-second-group">
              <th mat-header-cell *matHeaderCellDef [style.text-align]="'center'" [attr.colspan]="9"
                class="series-holding-table-th">
              </th>
            </ng-container>
            <!-- Header row third sction -->
            <ng-container matColumnDef="header-row-third-group">
              <th mat-header-cell *matHeaderCellDef [attr.colspan]="6"
                class="series-holding-table-th post-valuation-date-section"> Post Valuation Date
                Activity
              Including Cash Roll Forward </th>
            </ng-container>
            <!-- Header row fourth section -->
            <ng-container matColumnDef="header-row-fourth-group">
              <th mat-header-cell *matHeaderCellDef [attr.colspan]="1" class="series-holding-table-th">
              </th>
            </ng-container>
            <!-- Beginning Expanded Rows -->
            <ng-container matColumnDef="expandedDetail">
              <td *matCellDef="let deal; let j = dataIndex" [attr.colspan]="17" class="p-0">
                  @if (deal.isExpanded) {
                    <div animate.enter="detail-expand-enter" animate.leave="detail-expand-leave">
                      <table mat-table [dataSource]="deal.holdings" class="series-holding-table">
                        <!-- Name Column -->
                        <ng-container matColumnDef="name" sticky>
                          <td mat-cell *matCellDef="let holding; let first = first"
                            [ngClass]="{'border-top-0': first, 'width-305 max-w-175 lg:min-w-305': expandView, 'width-23': !expandView, 'shadow-background':displayShadowOnTable, 'normal-background':!displayShadowOnTable}"
                            class="text-left holding-row text-sm lg:text-md min-w-175"
                            [attr.colspan]="1" attr.data-cy="holdingRowCell0{{j}}">
                            <span
                              data-cy="holdingsRedirectLinkDisabled">
                              {{holding.name}}
                            </span>
                          </td>
                        </ng-container>
                        <!-- Commitment Date Column: holdings have no commitment date of their own -->
                        <ng-container matColumnDef="commitmentDate">
                          <td mat-cell *matCellDef="let holding; let first = first"
                            [ngClass]="{'border-top-0': first}"
                            class="text-left width-120 holding-row text-sm lg:text-md min-w-70 lg:min-w-120"
                            [attr.colspan]="1" data-cy="holdingCommitmentDate"> </td>
                        </ng-container>
                        <!-- Sector Column -->
                        <ng-container matColumnDef="sector">
                          <td mat-cell *matCellDef="let holding; let first = first"
                            class="text-left holding-row text-sm lg:text-md min-w-85"
                            [ngClass]="{'border-top-0': first, 'width-160 max-w-85 lg:min-w-160': expandView, 'width-12': !expandView}"
                            [attr.colspan]="1" data-cy="holdingSector">{{holding.sector}}
                          </td>
                        </ng-container>
                        <!-- Commitment Column -->
                        <ng-container matColumnDef="commitment">
                          <td mat-cell *matCellDef="let holding; let first = first"
                            class="text-right holding-row text-sm lg:text-md min-w-100"
                            [ngClass]="{'border-top-0': first, 'width-160 lg:min-w-160': expandView, 'width-10': !expandView}"
                            data-cy="holdingBalanceValue">
                            {{holding.commitment |
                            currencyFormat:currency():'Millions':true:true}}
                          </td>
                        </ng-container>
                        <!-- Contributions Column -->
                        <ng-container matColumnDef="contributions">
                          <td mat-cell *matCellDef="let holding; let first = first"
                            [ngClass]="{'border-top-0': first, 'width-245 lg:min-w-245': expandView, 'width-10': !expandView}"
                            class="text-right holding-row text-sm lg:text-md min-w-100"
                            data-cy="holdingBalanceValue">
                            {{(expandView ? holding.reportedContributions :
                            holding.contributions) |
                          currencyFormat:currency():'Millions':true:true}} </td>
                        </ng-container>
                        <!-- Distributions Column -->
                        <ng-container matColumnDef="distributions">
                          <td mat-cell *matCellDef="let holding; let first = first"
                            [ngClass]="{'border-top-0': first, 'width-245 lg:min-w-245': expandView, 'width-10': !expandView}"
                            class="text-right holding-row text-sm lg:text-md min-w-100"
                            data-cy="holdingBalanceValue">
                            {{(expandView ? holding.reportedDistributions :
                            holding.distributions) |
                          currencyFormat:currency():'Millions':true:true}} </td>
                        </ng-container>
                        <!-- Net Asset Value Column -->
                        <ng-container matColumnDef="nav">
                          <td mat-cell *matCellDef="let holding; let first = first"
                            [ngClass]="{'border-top-0': first, 'width-160 lg:min-w-160': expandView, 'width-10': !expandView}"
                            class="text-right holding-row text-sm lg:text-md min-w-70"
                            data-cy="holdingBalanceValue">
                          {{holding.nav | currencyFormat:currency():'Millions':true:true}} </td>
                        </ng-container>
                        <!-- Total Value Column -->
                        <ng-container matColumnDef="totalValue">
                          <td mat-cell *matCellDef="let holding; let first = first"
                            [ngClass]="{'border-top-0': first, 'width-160 lg:min-w-160': expandView, 'width-10': !expandView}"
                            class="text-right holding-row text-sm lg:text-md min-w-70"
                            data-cy="holdingBalanceValue">
                            {{holding.totalValue |
                          currencyFormat:currency():'Millions':true:true}} </td>
                        </ng-container>
                        <!-- TVPI Column -->
                        <ng-container matColumnDef="tvpi">
                          <td mat-cell *matCellDef="let holding; let first = first"
                            [ngClass]="{'border-top-0': first, 'width-160 border-right': expandView, 'width-7': !expandView}"
                            class="text-right holding-row text-sm lg:text-md min-w-70"
                            data-cy="holdingTvpiValue"> </td>
                        </ng-container>
                        <!-- IRR Column -->
                        <ng-container matColumnDef="irr">
                          <td mat-cell *matCellDef="let holding; let first = first"
                            [ngClass]="{'border-top-0': first, 'width-160': expandView, 'width-7': !expandView}"
                            class="text-right holding-row text-sm lg:text-md min-w-70"
                            data-cy="holdingIrrValue"> </td>
                        </ng-container>
                        <!-- Expanded View Columns -->
                        <!-- Investment Status Column -->
                        <ng-container matColumnDef="realizationType">
                          <td mat-cell *matCellDef="let holding; let first = first"
                            [ngClass]="{'border-top-0': first}"
                            class="text-left width-160 holding-row text-sm lg:text-md min-w-130 lg:min-w-160"
                            [attr.colspan]="1" data-cy="holdingInvestmentStatus">
                          {{holding.status}}</td>
                        </ng-container>
                        <!-- Valuation Date Column -->
                        <ng-container matColumnDef="valuationDate">
                          <td mat-cell *matCellDef="let holding; let first = first"
                            [ngClass]="{'border-top-0': first}"
                            class="text-left width-140 holding-row text-sm lg:text-md min-w-80 lg:min-w-140"
                            [attr.colspan]="1" data-cy="holdingValuationDate">
                            {{holding.valuationDate |
                          dateFormat: 'M/d/yy'}}</td>
                        </ng-container>
                        <!-- Remaining Commitment Column -->
                        <ng-container matColumnDef="remainingCommitment">
                          <td mat-cell *matCellDef="let holding; let first = first"
                            [ngClass]="{'border-top-0': first}"
                            class="text-right width-245 holding-row text-sm lg:text-md min-w-100 lg:min-w-245"
                            data-cy="holdingBalanceValueExpanded"> {{holding.remainingCommitment
                            |
                          currencyFormat:currency():'Millions':true:true}} </td>
                        </ng-container>
                        <!-- Reported Value Column -->
                        <ng-container matColumnDef="reportedValue">
                          <td mat-cell *matCellDef="let holding; let first = first"
                            [ngClass]="{'border-top-0': first}"
                            class="text-right width-160 holding-row text-sm lg:text-md min-w-70 lg:min-w-160"
                            data-cy="holdingBalanceValueExpanded"> {{holding.reportedValue |
                          currencyFormat:currency():'Millions':true:true}} </td>
                        </ng-container>
                        <!-- Subsequent Contributions Column -->
                        <ng-container matColumnDef="subsequentContributions">
                          <td mat-cell *matCellDef="let holding; let first = first"
                            [ngClass]="{'border-top-0': first}"
                            class="text-right width-245 holding-row text-sm lg:text-md border-left min-w-100 lg:min-w-245"
                            data-cy="holdingBalanceValueExpanded">
                            {{holding.subsequentContributions
                          | currencyFormat:currency():'Millions':true:true}} </td>
                        </ng-container>
                        <!-- Subsequent Distributions Column -->
                        <ng-container matColumnDef="subsequentDistributions">
                          <td mat-cell *matCellDef="let holding; let first = first"
                            [ngClass]="{'border-top-0': first}"
                            class="text-right width-245 holding-row text-sm lg:text-md min-w-100 lg:min-w-245"
                            data-cy="holdingBalanceValueExpanded">
                            {{holding.subsequentDistributions
                          | currencyFormat:currency():'Millions':true:true}} </td>
                        </ng-container>
                        <!-- Subsequent Investment Gain/Loss Column -->
                        <ng-container matColumnDef="fxGainLoss">
                          <td mat-cell *matCellDef="let holding; let first = first"
                            [ngClass]="{'border-top-0': first}"
                            class="text-right width-160 holding-row text-sm lg:text-md min-w-100 lg:min-w-160"
                            data-cy="holdingBalanceValueExpanded">
                            {{holding.fxGainLoss
                          | currencyFormat:currency():'Millions':true:true}} </td>
                        </ng-container>
                        <tr mat-row *matRowDef="let holding; columns: columnsToDisplay;"
                        attr.data-cy="holdingRow{{holding.masterId}}"></tr>
                      </table>
                    </div>
                  }
              </td>
            </ng-container>
            <!-- Ending Expanded Rows -->
            <tr mat-header-row
              *matHeaderRowDef="['header-row-first-group','header-row-second-group','header-row-third-group','header-row-fourth-group']; sticky: expandView"
            [ngClass]="{'hidden': !expandView}"></tr>
            <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
            <tr mat-row *matRowDef="let deal; columns: columnsToDisplay;"
              tourAnchor="series.dashboard.investment.holding" attr.data-cy="dealRow{{deal.masterId}}">
            </tr>
            <tr mat-row *matRowDef="let deal; columns: ['expandedDetail']"
            [ngClass]="{'hidden': !deal.isExpanded}"></tr>
          </table>
        </div>
      </div>
    </div>
  } @else {
    <div class="w-full series-table-error" data-cy="noResults">
      <div class="row">
        <div class="col-12">
          <div class=" mt-3">
            <div>
              <p class="text-center error-message">No Results</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}
